"use strict";
var toString = require("../internals/to-string");
module.exports = function(argument, $default) {
  return argument === void 0 ? arguments.length < 2 ? "" : $default : toString(argument);
};
